import React from 'react';
import { Link } from 'react-router-dom';
import { useStaggerReveal } from '../hooks/useScrollReveal';
import './ServiceCards.css';

const services = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
      </svg>
    ),
    title: 'Psychotherapy, Counselling & Assessment',
    description: 'For anxiety, depression, stress, grief, trauma and relationship issues. Evidence-based talk therapy with CBT, DBT and other proven approaches.',
    to: '/services#psychotherapy',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="6"/>
        <circle cx="12" cy="12" r="2" fill="currentColor"/>
      </svg>
    ),
    title: 'Hypnotherapy & NLP',
    description: 'Break stuck patterns: phobias, addictions, sleep issues, overthinking. Guided clinical hypnotherapy and healing & energy work for deeper change.',
    to: '/services#hypnotherapy',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18"/>
        <path d="M7 14l4-4 4 4 5-5"/>
      </svg>
    ),
    title: 'Coaching & Career Counselling',
    description: 'Practical, goal-oriented sessions for students, professionals and executives. Build confidence, clarity and decision-making for what’s next.',
    to: '/services#coaching',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <path d="M9 13l2 2 4-4"/>
      </svg>
    ),
    title: 'Hypnotherapy Practitioner Training',
    description: 'CHI-USA certified, certification-track programs in clinical hypnotherapy, counselling skills and allied modalities. For aspiring therapists & coaches.',
    to: '/services#training',
  },
];

const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

const ServiceCards = () => {
  const gridRef = useStaggerReveal({ staggerDelay: 120, childSelector: '.service-card' });

  return (
    <section className="service-cards">
      <div className="container">
        <div className="service-cards__grid" ref={gridRef}>
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.to}
              className="service-card stagger-item"
            >
              <div className="service-card__top">
                <span className="service-card__icon" aria-hidden="true">
                  {service.icon}
                </span>
                <span className="service-card__num">0{index + 1}</span>
              </div>

              <div className="service-card__body">
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__desc">{service.description}</p>
              </div>

              <div className="service-card__foot">
                <span className="service-card__cta">
                  Learn more
                  <ArrowIcon />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
